import { render, staticRenderFns } from "./c-edit-audience-popup.vue?vue&type=template&id=6e220d52&scoped=true"
import script from "./c-edit-audience-popup.vue?vue&type=script&lang=js"
export * from "./c-edit-audience-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e220d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e220d52')) {
      api.createRecord('6e220d52', component.options)
    } else {
      api.reload('6e220d52', component.options)
    }
    module.hot.accept("./c-edit-audience-popup.vue?vue&type=template&id=6e220d52&scoped=true", function () {
      api.rerender('6e220d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/release/popups/c-edit-audience-popup.vue"
export default component.exports